import React from "react";
import { StyleSheet, View } from "react-native";

import CustomText from "../../../../../components/common/general/CustomText/CustomText";
import type { CourseEvaluatorReviewSidebarItemMock } from "../mockData/courseEvaluatorReview.mockData";
import { colors } from "../../../../../styles/design-system";

interface ModuleDescriptionPanelProps {
  selectedReviewItem: CourseEvaluatorReviewSidebarItemMock;
}

function ModuleDescriptionPanel({ selectedReviewItem }: ModuleDescriptionPanelProps) {
  return (
    <View style={styles.card}>
      <CustomText
        text={selectedReviewItem.title}
        useTranslationText={false}
        size="xxl"
        weight="ultraBold"
        style={styles.heroTitle}
      />
      <CustomText
        text="Module description panel is not implemented yet. This panel shell is now aligned with the evaluator page structure for a future task."
        useTranslationText={false}
        size="l"
        style={styles.placeholderBodyText}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: "#FFFFFF",
    borderWidth: 1,
    borderColor: colors.grey[200],
    borderRadius: 16,
    padding: 20,
  },
  heroTitle: {
    color: colors.grey[900],
  },
  placeholderBodyText: {
    color: colors.grey[600],
    marginTop: 16,
    lineHeight: 22,
  },
});

export default ModuleDescriptionPanel;
